import DOMPurify from 'dompurify';

/**
 * Allowlist HTML sanitisation (ticket rich text, Microsoft Secure Score, etc.)
 * via DOMPurify — do not hand-roll HTML parsing/cleaning; browser HTML quirks
 * make custom sanitisers unsafe.
 *
 * Ticket descriptions are also sanitised on the API (`HelpdeskHtmlSanitizer`) —
 * keep ALLOWED_TAGS / attrs aligned with that helper.
 */

const ALLOWED_TAGS = [
  'p', 'br', 'strong', 'b', 'em', 'i', 'ul', 'ol', 'li', 'a', 'span', 'div',
  'h1', 'h2', 'h3', 'h4',
];
const ALLOWED_ATTR = ['href', 'target', 'rel'];

// Only http(s)/mailto hrefs, same-page fragments, or root-relative paths — blocks javascript:, data:, //evil.
const SAFE_URI_REGEXP = /^(?:https?:|mailto:|#|\/(?!\/))/i;

let linkHookRegistered = false;

function ensureLinkHook() {
  if (linkHookRegistered) return;
  linkHookRegistered = true;
  DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName !== 'A') return;
    // Defence in depth for any surviving anchor (tabnabbing / window.opener).
    node.setAttribute('rel', 'noopener noreferrer');
    node.setAttribute('target', '_blank');
  });
}

export function sanitizeHtmlAllowlist(dirty) {
  if (dirty == null || dirty === '') return '';
  ensureLinkHook();
  return DOMPurify.sanitize(String(dirty), {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOWED_URI_REGEXP: SAFE_URI_REGEXP,
  });
}
